import { Component, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';

import { BaseSectionComponent } from 'app/shared/base-classes/sections/base-section.component';
import { InputFieldComponent } from 'app/shared/components/input-field/input-field.component';

import { SectionWrapperComponent } from '../../../../../../shared/components/containers/section-wrapper-container/section-wrapper-container.component';
import { DurationPickerComponent } from '../../../../../../shared/components/duration-picker/duration-picker.component';
import {
	dateCast,
	toDateString,
} from '../../../../../../shared/functions/sectionCasters.function';
import { VehicleRoadWorthyCheckRecordModel } from '../../../models/vehicle-road-worthy-check-record.model';
import { VEHICLE_ROAD_WORTHY_CHECK_RECORD_CATEGORIES } from '../../../translations/vehicle-road-worthy-checks-select-items';

@Component({
	selector: 'app-vehicle-road-worthy-checks-details',
	templateUrl: 'vehicle-road-worthy-checks-details.component.html',
	imports: [
		ReactiveFormsModule,
		InputFieldComponent,
		SectionWrapperComponent,
		DurationPickerComponent,
	],
})
export class VehicleRoadWorthyChecksDetailsComponent
	extends BaseSectionComponent<VehicleRoadWorthyCheckRecordModel>
	implements OnInit
{
	protected _skipCount: number = 0;
	public recordCategories = VEHICLE_ROAD_WORTHY_CHECK_RECORD_CATEGORIES;

	constructor(private _formBuilder: FormBuilder) {
		super();
		this.detailsForm = this._formBuilder.group({
			code: [null],

			externalReference: [null],
			startsAt: [null],
			endsAt: [null],
			recordCategory: [null],
		});
	}

	protected _mapModelToForm(): void {
		const detailsFormData: any = {
			code: this.recordData().code,

			externalReference: this.recordData().externalReference,
			startsAt: toDateString(this.recordData().startsAt),
			endsAt: toDateString(this.recordData().endsAt),
			recordCategory: this.recordData().recordCategory,
		};
		this.detailsForm.setValue(detailsFormData, {
			emitEvent: false,
		});
	}

	protected _mapFormToModel(): Partial<VehicleRoadWorthyCheckRecordModel> {
		return {
			code: this.detailsForm.value.code,

			externalReference: this.detailsForm.value.externalReference,
			startsAt: dateCast(this.detailsForm.value.startsAt),
			endsAt: dateCast(this.detailsForm.value.endsAt),
			recordCategory: this.detailsForm.value.recordCategory,
		};
	}
}
